/**
 * Team scorecard — per-user completion %, missed %, weighted score across all
 * owned channels.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Trophy, Loader2 } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import "./studio.css";

const API = process.env.REACT_APP_BACKEND_URL || '';

export default function StudioScorecard() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/studio/scorecard`, { withCredentials: true })
      .then((r) => setRows(r.data.team || []))
      .catch(() => setRows([]));
  }, []);

  return (
    <>
      <Header />
      <div className="studio-shell">
        <Link to="/studio" className="studio-back" data-testid="score-back">
          <ArrowLeft size={14}/> Back to Studio
        </Link>
        <div style={{ marginTop: 12 }}>
          <span className="studio-eyebrow"><Trophy size={12}/> Team scorecard</span>
          <h2 style={{ margin: "6px 0 18px" }}>Who&apos;s shipping &amp; who&apos;s slipping</h2>
        </div>
        {rows === null ? (
          <div className="studio-card studio-loading">
            <Loader2 size={22} className="ac-spin" style={{ color: "var(--st-purple, #a78bfa)" }}/>
          </div>
        ) : rows.length === 0 ? (
          <div className="studio-card"><p className="studio-muted">No team activity yet.</p></div>
        ) : (
          <div className="studio-card">
            <table className="studio-table" data-testid="scorecard-table">
              <thead>
                <tr>
                  <th>Member</th><th>Total</th><th>Completed</th><th>In progress</th>
                  <th>Missed</th><th>Completion %</th><th>Score</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.user_id} data-testid={`scorecard-${r.user_id}`}>
                    <td>{r.user?.name || r.user?.email || r.user_id.slice(0, 8)}</td>
                    <td>{r.total}</td>
                    <td>{r.completed}</td>
                    <td>{r.in_progress}</td>
                    <td className={r.missed > 0 ? "studio-bad" : ""}>{r.missed}</td>
                    <td>{r.completion_pct}%</td>
                    <td><strong>{r.score}</strong></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}
